import ApiService from '../../services/apiService';
import { mapState, mapMutations, mapGetters } from 'vuex';
export default {
  name: 'CoreFavoriteselect',
  props: {
    userId: {
      type: String,
      required: false,
      default: ''
    },
    objectId: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    asRoundButton: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      favStatus: null,
      favId: null,
      favObject: null,
      favObjectId: null,
      loading: true
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    ...mapGetters({
      sessionUserId: 'authentication/userId'
    }),
    icon() {
      return this.favObjectId ? 'fas fa-star' : 'fal fa-star';
    }
  },
  watch: {
    objectId() {
      if (this.objectId) {
        this.getStatus();
      }
    }
  },
  mounted() {
    if (this.objectId) {
      this.getStatus();
    }
  },
  methods: {
    ...mapMutations('app', ['snackbar']),
    getStatus() {
      let user;
      this.loading = true;
      if (!this.userId) {
        user = this.sessionUserId;
      } else {
        user = this.userId;
      }
      return ApiService.getFavoritesByObjectIdUserId(this.objectId, user, this.type).then(result => {
        result ? this.favObjectId = result.id : this.favObjectId = null;
        this.favObject = result;
        return result;
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack('Failed to load Favorite', 'error');
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    process() {
      let user;
      if (!this.userId) {
        user = this.sessionUserId;
      } else {
        user = this.userId;
      }
      // clear cache, as the twin favourite-filter needs to fetch new stuff
      this.$store.state.app.dtwins = {};
      if (!this.favObjectId) {
        const data = {
          userId: user,
          objectId: this.objectId,
          type: this.type
        };
        return ApiService.createFavorite(data).then(() => {
          this.getStatus();
        }).catch(error => {
          if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
            this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
          } else {
            this.$snack('Failed to create Favorite', 'error');
          }
        });
      } else {
        return ApiService.deleteFavorite(this.favObjectId).then(() => {
          this.getStatus();
        }).catch(error => {
          if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
            this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
          } else {
            this.$snack('Failed to delete Favorite', 'error');
          }
        });
      }
    }
  }
};